module.exports = __webpack_public_path__ + "media/giggle2.6e5aa989.mp3";